// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1CDCEnrichmentMode } from './V1CDCEnrichmentMode';
import {
  V1CDCEnrichmentModeFromJSON,
  V1CDCEnrichmentModeFromJSONTyped,
  V1CDCEnrichmentModeToJSON,
  V1CDCEnrichmentModeToJSONTyped,
} from './V1CDCEnrichmentMode';
import type { V1CypherVersionConfig } from './V1CypherVersionConfig';
import {
  V1CypherVersionConfigFromJSON,
  V1CypherVersionConfigFromJSONTyped,
  V1CypherVersionConfigToJSON,
  V1CypherVersionConfigToJSONTyped,
} from './V1CypherVersionConfig';
import type { V1StoreFormatConfig } from './V1StoreFormatConfig';
import {
  V1StoreFormatConfigFromJSON,
  V1StoreFormatConfigFromJSONTyped,
  V1StoreFormatConfigToJSON,
  V1StoreFormatConfigToJSONTyped,
} from './V1StoreFormatConfig';

/**
 *
 * @export
 * @interface V1DatabaseConfig
 */
export interface V1DatabaseConfig {
  /**
   *
   * @type {V1CDCEnrichmentMode}
   * @memberof V1DatabaseConfig
   */
  enrichmentMode?: V1CDCEnrichmentMode;
  /**
   *
   * @type {number}
   * @memberof V1DatabaseConfig
   */
  graphShardPrimaries?: number;
  /**
   *
   * @type {number}
   * @memberof V1DatabaseConfig
   */
  graphShardSecondaries?: number;
  /**
   *
   * @type {V1CypherVersionConfig}
   * @memberof V1DatabaseConfig
   */
  initialDefaultLanguage?: V1CypherVersionConfig;
  /**
   *
   * @type {number}
   * @memberof V1DatabaseConfig
   */
  primaries?: number;
  /**
   *
   * @type {number}
   * @memberof V1DatabaseConfig
   */
  propertyShardCount?: number;
  /**
   *
   * @type {number}
   * @memberof V1DatabaseConfig
   */
  propertyShardReplicaCount?: number;
  /**
   *
   * @type {boolean}
   * @memberof V1DatabaseConfig
   */
  readOnly?: boolean;
  /**
   *
   * @type {number}
   * @memberof V1DatabaseConfig
   */
  secondaries?: number;
  /**
   *
   * @type {string}
   * @memberof V1DatabaseConfig
   */
  seedUri?: string;
  /**
   *
   * @type {V1StoreFormatConfig}
   * @memberof V1DatabaseConfig
   */
  storeFormat?: V1StoreFormatConfig;
}

/**
 * Check if a given object implements the V1DatabaseConfig interface.
 */
export function instanceOfV1DatabaseConfig(
  value: object,
): value is V1DatabaseConfig {
  return true;
}

export function V1DatabaseConfigFromJSON(json: any): V1DatabaseConfig {
  return V1DatabaseConfigFromJSONTyped(json, false);
}

export function V1DatabaseConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1DatabaseConfig {
  if (json == null) {
    return json;
  }
  return {
    enrichmentMode:
      json['enrichmentMode'] == null
        ? undefined
        : V1CDCEnrichmentModeFromJSON(json['enrichmentMode']),
    graphShardPrimaries:
      json['graphShardPrimaries'] == null
        ? undefined
        : json['graphShardPrimaries'],
    graphShardSecondaries:
      json['graphShardSecondaries'] == null
        ? undefined
        : json['graphShardSecondaries'],
    initialDefaultLanguage:
      json['initialDefaultLanguage'] == null
        ? undefined
        : V1CypherVersionConfigFromJSON(json['initialDefaultLanguage']),
    primaries: json['primaries'] == null ? undefined : json['primaries'],
    propertyShardCount:
      json['propertyShardCount'] == null
        ? undefined
        : json['propertyShardCount'],
    propertyShardReplicaCount:
      json['propertyShardReplicaCount'] == null
        ? undefined
        : json['propertyShardReplicaCount'],
    readOnly: json['readOnly'] == null ? undefined : json['readOnly'],
    secondaries: json['secondaries'] == null ? undefined : json['secondaries'],
    seedUri: json['seedUri'] == null ? undefined : json['seedUri'],
    storeFormat:
      json['storeFormat'] == null
        ? undefined
        : V1StoreFormatConfigFromJSON(json['storeFormat']),
  };
}

export function V1DatabaseConfigToJSON(json: any): V1DatabaseConfig {
  return V1DatabaseConfigToJSONTyped(json, false);
}

export function V1DatabaseConfigToJSONTyped(
  value?: V1DatabaseConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    enrichmentMode: V1CDCEnrichmentModeToJSON(value['enrichmentMode']),
    graphShardPrimaries: value['graphShardPrimaries'],
    graphShardSecondaries: value['graphShardSecondaries'],
    initialDefaultLanguage: V1CypherVersionConfigToJSON(
      value['initialDefaultLanguage'],
    ),
    primaries: value['primaries'],
    propertyShardCount: value['propertyShardCount'],
    propertyShardReplicaCount: value['propertyShardReplicaCount'],
    readOnly: value['readOnly'],
    secondaries: value['secondaries'],
    seedUri: value['seedUri'],
    storeFormat: V1StoreFormatConfigToJSON(value['storeFormat']),
  };
}
